import { useState } from 'react';
import { useCreditsContext } from '../../contexts/CreditsContext';
import { useUser } from '../../contexts/UserContext';
import { useAnalysisContext } from '../../contexts/AnalysisContext';
import { API_URL } from '../../constants/api';

export function CreditDisplay() {
  const { credits, subscription, isSubscriber, setShowPricingModal } = useCreditsContext();
  const { isAdmin, deviceId } = useUser();
  const { analysisResult } = useAnalysisContext();
  const [portalLoading, setPortalLoading] = useState(false);
  const viewingResults = !!analysisResult;

  // Open Stripe Customer Portal for subscription management
  const openBillingPortal = async () => {
    if (!deviceId || portalLoading) return;

    setPortalLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/billing/portal`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ deviceId })
      });

      const data = await response.json();
      if (data.url) {
        window.location.href = data.url;
      } else {
        console.error('No portal URL returned');
        alert('Unable to open billing portal. Please try again.');
      }
    } catch (error) {
      console.error('Portal error:', error);
      alert('Unable to open billing portal. Please try again.');
    } finally {
      setPortalLoading(false);
    }
  };

  if (isAdmin) {
    return (
      <div className="rounded-lg px-2 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm font-medium border bg-purple-500/10 border-purple-500/30 text-purple-400 flex items-center gap-1 sm:gap-2">
        <span>👑</span>
        <span className="font-bold">∞</span>
        <span className="hidden sm:inline text-purple-300">Admin</span>
      </div>
    );
  }

  if (isSubscriber) {
    return (
      <div className="flex items-center gap-2 sm:gap-3">
        <div className="rounded-lg px-2 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm font-medium border bg-emerald-500/10 border-emerald-500/30 text-emerald-400 flex items-center gap-1 sm:gap-2">
          <span className="text-emerald-400">Sub</span>
          {subscription?.renewalDate && (
            <span className="hidden sm:inline text-emerald-300/60 text-xs">
              renews {new Date(subscription.renewalDate).toLocaleDateString()}
            </span>
          )}
        </div>
        <button
          onClick={openBillingPortal}
          disabled={portalLoading}
          className="rounded-lg bg-gradient-to-r from-emerald-500 to-green-500 px-3 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm font-bold text-black hover:scale-105 transition whitespace-nowrap disabled:opacity-50"
        >
          {portalLoading ? '...' : 'Manage'}
        </button>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 sm:gap-3">
      <div className={`rounded-lg px-2 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm font-medium border whitespace-nowrap ${
        credits === 0 && !viewingResults
          ? 'bg-red-500/10 border-red-500/30 text-red-400'
          : credits <= 2 && !viewingResults
          ? 'bg-amber-500/10 border-amber-500/30 text-amber-400'
          : 'bg-white/5 border-white/10 text-white'
      }`}>
        <span className={credits === 0 && !viewingResults ? 'text-red-400' : credits <= 2 && !viewingResults ? 'text-amber-400' : 'text-slate-400'}>
          {credits}
        </span>
        <span className="text-white"> {credits === 1 ? 'credit' : 'credits'}</span>
      </div>
      <button
        onClick={() => setShowPricingModal(true)}
        className="rounded-lg bg-gradient-to-r from-emerald-500 to-green-500 px-3 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm font-bold text-black hover:scale-105 transition whitespace-nowrap"
      >
        Buy
      </button>
    </div>
  );
}
